
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { adminapi, orgapi } from "../../ApiNames";

export const fetchadddatasuccess = (adddata:any)=>({
    type : 'fetch_Add_data_success',
    payload:adddata
});
export const fetchDataSuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})
export const AddData = (uid:any,needId:any, title: any, budget_amount: any, description: any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid,needtype: needId, title: title, budget: budget_amount, description: description,};
            const apiname = orgapi.organizationaddneeds;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchadddatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};
export const fetchData = ()=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {};
            const apiname = adminapi.adneed;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
};


